import React, { useState } from "react";
import CustomTextField from "./CustomTextField";

const Title = ({ text, onEdit, id, isEditing, setEditableItemId }) => {
  const [editedText, setEditedText] = useState(text);

  const handleBlur = async () => {
    await onEdit(id, editedText);
    setEditableItemId(null);
  };

  const handleInputChange = (e) => {
    setEditedText(e.target.value);
  };

  return (
    <div>
      {!isEditing ? (
        <h4>{editedText}</h4>
      ) : (
        <CustomTextField
          sx={{
            padding: "0",
            width: "30rem",
          }}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
          label="Category Name"
          color="black"
          size="inherit"
          value={editedText}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDownCapture={(e) => (e.key === "Enter" ? handleBlur() : null)}
          autoFocus
        />
      )}
    </div>
  );
};
export default Title;
